import { useCallback, useState } from 'react';

import { getPaymentsStatuses as getPaymentsStatusesRequest } from 'PrivateAPI';

import { captureExceptionWithTeam } from 'Utilities/captureException/captureExceptionWithTeam';
import { TEAM } from 'Utilities/constants';

import { PaymentStatuses } from '../../../containers/app/payments/Payments.types';

const useGetPaymentsStatuses = () => {
  const [data, setData] = useState<PaymentStatuses | null>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isFetched, setIsFetched] = useState<boolean>(false);

  const getPaymentsStatuses = useCallback(async (dpEnquiryId: number) => {
    setIsLoading(true);
    try {
      const response = await getPaymentsStatusesRequest(dpEnquiryId);
      if (response && response.data) {
        const mwToSeller: PaymentStatuses = response.data.find((item: any) => item.type === 'mw_to_seller');
        setData(mwToSeller ? { ...mwToSeller } : null);
      }
    } catch (err) {
      setData(null);
      captureExceptionWithTeam(
        err,
        TEAM.PAYMENTS_FE,
        {
          extra: {
            dpEnquiryId,
          },
          tags: {
            fetch: 'useGetPaymentsStatuses',
          },
        },
      );
    }
    setIsLoading(false);
    setIsFetched(true);
  }, []);

  return {
    data,
    getPaymentsStatuses,
    isFetched,
    isLoading,
    isSuccess: !!(data || data === null),
  };
};

export default useGetPaymentsStatuses;
